module.exports = __webpack_public_path__ + "img/header-engagementRingsVintage.6e5de9b.jpg";